<div style="margin-top: 5px;">
  <div class="modal-content">
    <div class="header-tab text-center mb-2 mt-2">
      <div class="row">
        <div class="col-xs-4 col-sm-12 col-md-4 col-lg-4">
          <div [ngClass]="selectedTab === 'nameAndContact' ? 'selectedTab' : 'defaultTab' "
            (click)="onTabClick('nameAndContact');">
            Name And Contact
          </div>
        </div>
        <div *ngIf="!(this.context === 'allotmentContext')" class="col-xs-4 col-sm-12 col-md-4 col-lg-4">
          <div [ngClass]="selectedTab === 'addresses'  ? 'selectedTab' : 'defaultTab' "
            (click)="onTabClick('addresses')">
            Addresses
          </div>
        </div>
        <div *ngIf="!(this.context === 'allotmentContext')" class="col-xs-4 col-sm-12 col-md-4 col-lg-4">
          <div [ngClass]="selectedTab === 'bankAccount'  ? 'selectedTab' : 'defaultTab' "
            (click)="onTabClick('bankAccount')">
            Bank Account
          </div>
        </div>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="customerForm">
        <!-- Name And Contact List Form Update -->
        <div *ngIf="selectedTab === 'nameAndContact'">
          <app-name-contact [customerData]="currentCustomersData" [userData]="userData"></app-name-contact>
        </div>

        <!-- User Profile Identification Form -->
        <div *ngIf="selectedTab === 'addresses'">
          <app-user-address [context]="context" [customerData]="currentCustomer"></app-user-address>
        </div>
        <!-- User Profile Identification Form -->
        <div *ngIf="selectedTab === 'bankAccount'">
          <app-bank-Account [customerData]="currentCustomersData"
            (customerDataUpdated)="onCustomerDataUpdated($event)"></app-bank-Account>
          <!-- <app-bank-add></app-bank-add>
            <app-bank-list></app-bank-list> -->
        </div>
      </form>
    </div>
  </div>
</div>